<template>
    <div v-if="compare" class="patentCompare-toggler-container">
        <ElPopover
            v-if="compare.enabled"
            :visibleArrow="false"
            placement="bottom"
            trigger="hover"
        >
            <PtIcon slot="reference" icon="SolidInfo" class="solid-info-icon" />
            <p style="max-width: 500px; word-break: break-word;" v-html="$t(`${compare.tag}['compareTip']`)" />
        </ElPopover>
        <div class="patentCompare-toggler">
            <PtToggler v-model="compare.enabled" />
            <span v-if="compare.fullList.length <= 1" class="compare-single">
                {{ $t(`patent-view['COMPARE_WITH']`, {pn: compare.target.name}) }}
            </span>
            <PtDropdown
                v-else
                ref="patentCompare"
                v-clickoutside="() => $refs.patentCompare.hide()"
                trigger="click"
                class="apply-auto-arrow"
                :class="{'has-drop': compare.fullList.length > 1}"
                placement="bottom-end"
                @command="func => func()"
            >
                <button
                    type="alt-white"
                    class="pt-ui-btn"
                    data-size="small"
                    data-type="transparent"
                >
                    <span class="patentCompare-toggler__inner-text">{{ $t(`patent-view['COMPARE_WITH']`, {pn: compare.target.name}) }}</span>
                    <PtIcon icon="SolidDropdownOpen" class="el-icon--right" />
                    <PtIcon icon="SolidDropdownClose" class="el-icon--right" />
                </button>
                <PtDropdownMenu v-show="compare.fullList.length > 1" slot="dropdown" class="patentCompare-Menu_content">
                    <div class="compare-dropdown-menu__container">
                        <div v-for="(typeList, typeKey) in compare.type" :key="typeKey" class="patentCompare_type_box">
                            <div class="patentCompare-drop-group">
                                <span class="patentCompare-drop-group-item">
                                    {{ $t(`compareWithType['${typeKey}']`) }}
                                </span>
                            </div>
                            <PtDropdownItem
                                v-for="item in typeList"
                                :key="item.id"
                                :class="['clmcompare-dropdown-item', { 'is-checked': item.id === compare.target.id }]"
                                :command="() => setTargetIdx(item.id)"
                            >
                                <span class="clmcompare-dropdown-item__label"> {{ item.name }} </span>
                                <PtIcon v-if="item.id === compare.target.id" icon="SolidTick" />
                            </PtDropdownItem>
                            <div v-if="data.hasMultiViewPermission && typeKey === 'CLM_MODIFY'">
                                <FileWrapperMultiViewButton
                                    :patentId="patentId"
                                    class="clms__view-handle__item"
                                />
                            </div>
                        </div>
                    </div>
                </PtDropdownMenu>
            </PtDropdown>
        </div>
    </div>
</template>

<script>
import { Toggler, Dropdown, DropdownMenu, DropdownItem } from 'patsnap-ui';
import { Icon } from 'patsnap-biz';
import { Popover } from 'element-ui';
import clickoutside from 'element-ui/src/utils/clickoutside';
import FileWrapperMultiViewButton from '../file-wrapper-multi-view/FileWrapperMultiViewButton.vue';
import _ from 'lodash';
import '@patsnap-ui/icon/assets/solid/info.svg';
import '@patsnap-ui/icon/assets/solid/DropdownOpen.svg';
import '@patsnap-ui/icon/assets/solid/DropdownClose.svg';
import '@patsnap-ui/icon/assets/solid/tick.svg';
export default {
    name: 'CompareSelect',
    components: {
        PtIcon: Icon,
        PtDropdown: Dropdown,
        PtDropdownMenu: DropdownMenu,
        PtDropdownItem: DropdownItem,
        ElPopover: Popover,
        PtToggler: Toggler,
        FileWrapperMultiViewButton,
    },
    directives: {
        clickoutside,
    },
    props: {
        patentId: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
        },
    },
    data() {
        return {
            compare: null,
        };
    },
    watch: {
        data: {
            handler() {
                this.formatCompareData();
            },
            deep: true,
        },
        'compare.enabled'(bol) {
            this.$emit('enabledChange', bol);
        },
    },
    mounted() {
        this.formatCompareData();
    },
    methods: {
        setTargetIdx(id) {
            for (let i = 0; i < this.compare.fullList.length; i++) {
                if (this.compare.fullList[i].id === id) {
                    this.$emit('idxChange', i);
                    break;
                }
            }
        },
        formatCompareData() {
            this.compare = _.cloneDeep(this.data);
        },
    },
};
</script>

<style lang="scss">
.patentCompare-toggler-container {
    display: flex;
    align-items: center;
    //margin-top: 1px;
    .solid-info-icon {
        vertical-align: -7px;
        fill: $text-disable;
    }
    .patentCompare-toggler {
        background-color: #f4f5f7;
        color: #061632;
        padding: 4px 8px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        &:hover {
            background-color: #ebecf0;
        }
        .compare-single {
            font-size: 12px;
            line-height: 12px;
            padding: 6px 0;
            color: #061632;
        }
        .pt-ui-btn, .pt-ui-btn:hover {
            background-color: transparent !important;
            padding: 0;
            .el-icon--right {
                font-size: 24px;
                margin-left: 5px;
            }
        }
        .patsnap-ui-dropdown--visible .pt-ui-btn--alt-white,
        .pt-ui-btn--alt-white:hover{
            border-color: rgba(0,0,0,0);
            background-color: #ebecf0;
        }
        .pt-ui-btn__text {
            display: flex;
            align-items: center;
        }
        .patentCompare-toggler__inner-text {
            display: inline-block;
            font-size: 12px;
            line-height: 12px;
            text-align: left;
        }
        .pt-toggler {
            height: 20px;
        }
        .pt-toggler__switch-wrap {
            width: 32px;
            margin-right: 4px;
        }
        .pt-toggler[aria-checked=false] .pt-toggler__switch-wrap {
            background: #b3bac5;
        }
    }
    .patsnap-ui-dropdown.apply-auto-arrow{
        [icon="SolidDropdownOpen"] {
            float: right !important;
            display:inline-block !important;
        }
        [icon="SolidDropdownClose"] {
            float: right !important;
            display:none !important;
        }
        .pt-ui-btn:active{
            background-color: #ebecf0;
            border-color: #ebecf0;
        }
    }
    .patsnap-ui-dropdown--visible.apply-auto-arrow{
        [icon="SolidDropdownOpen"] {
            display:none !important;
        }
        [icon="SolidDropdownClose"] {
            display:inline-block !important;
        }
    }
}

.patentCompare-Menu_content {
  padding: 0 !important;
  min-width: 278px;
  left: 8px !important;
  top: 5px !important;
  .compare-dropdown-menu__container {
    padding: 8px 0;
    max-height: 398px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .clmcompare-dropdown-item{
    margin: 0 15px;
    &.is-checked{
      color: #1D8820;
    }
    .patsnap-biz-icon {
      float: right;
      fill: #1D8820 !important;
      margin-bottom: 0;
      font-size: 24px;
    }
  }
  .patentCompare-drop-group {
    color: #b3bac5;
    font-size: 12px;
    padding: 8px 15px;
    margin-top: 8px;
    border-top: 1px solid #b3bac5;
  }
  .patentCompare_type_box:first-child .patentCompare-drop-group{
    border-top: none;
    margin-top: 0;
  }
}
</style>
